<template>
  <div :class="[$style.wrapper, !isOpen ? $style.hide : null]">
    <div
      :class="[$style.content, { [$style.deleteIndent]: this.$store.state.deleteIndent }]"
      :style="contentStyle"
    >
      <div :class="$style.field">
        <p :class="$style.title">Категория</p>
        <select v-model="category" :class="$style.button_transparent">
          <option v-for="category in categories" :key="category" :value="category">
            {{ category }}
          </option>
        </select>
      </div>

      <div :class="$style.field">
        <p :class="$style.title">Название</p>
        <input v-model="header" type="text" ref="header" :class="$style.button_transparent" />
      </div>

      <div :class="$style.field">
        <p :class="$style.title">Описание</p>
        <div :class="$style.editor_container">
          <Editor
            v-model="description"
            type="text"
            ref="description"
            :class="$style.editor"
            :modules="editorModules"
          ></Editor>
        </div>
      </div>

      <div :class="$style.field">
        <p :class="$style.title">Цена</p>
        <input
          v-model="formattedPrice"
          type="text"
          ref="price"
          :class="$style.button_transparent"
          @input="formatPriceInput"
        />
      </div>

      <div :class="$style.field">
        <p :class="$style.title">Ачивки</p>
        <input
          v-model="additionOne"
          type="text"
          ref="additionOne"
          :class="[$style.button_transparent, $style.addition]"
        />
        <input
          v-model="additionTwo"
          type="text"
          ref="additionTwo"
          :class="[$style.button_transparent, $style.addition]"
        />
        <input
          v-model="additionThree"
          type="text"
          ref="additionThree"
          :class="[$style.button_transparent, $style.addition]"
        />
        <input
          v-model="additionFour"
          type="text"
          ref="additionFour"
          :class="[$style.button_transparent, $style.addition]"
        />
      </div>

      <div :class="$style.field">
        <p :class="$style.title">Супер-предложение</p>
        <input
          v-model="superAddition"
          type="text"
          ref="superAddition"
          :class="$style.button_transparent"
        />
      </div>

      <div :class="$style.field">
        <p :class="$style.title">Адрес</p>
        <input v-model="address" type="text" ref="address" :class="$style.button_transparent" />
      </div>

      <hr />

      <div v-if="photoUrls.length" :class="$style.photo">
        <draggable v-model="photoUrls" group="photos" item-key="id" @change="onPhotosChange">
          <template #item="{ element, index }">
            <div :class="$style.photo_preview">
              <img :src="element" alt="Фото" :class="$style.photo_item" />
              <button :class="$style.remove_button" @click="removePhoto(index)">
                <img src="../assets/img/delete.svg" alt="" :class="$style.delete_icon" />Удалить
                фото
              </button>
            </div>
          </template>
        </draggable>
      </div>

      <div :class="$style.custom">
        <label for="photo_urls" :class="$style.custom_button" @click="triggerHapticFeedback">
          <img src="../assets/img/add_photo.svg" alt="" :class="$style.img" />Добавить фото
        </label>
        <input
          type="file"
          id="photo_urls"
          @change="handleFileChange"
          :class="$style.hidden"
          multiple
        />
      </div>

      <div :class="$style.field">
        <button :class="$style.button" @click="submitForm">
          <img src="../assets/img/plus.svg" alt="" :class="$style.img" />Добавить карточку
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import Editor from 'primevue/editor';

export default {
  components: { Editor, draggable },
  data() {
    return {
      isOpen: true,
      photoUrls: [],
      category: '',
      categories: ['Новостройки', 'Вторичные', 'Коммерция', 'Загородная', 'Аренда', 'Сити'],
      header: '',
      description: '',
      photos: [],
      contentStyle: {},
      price: '',
      additionOne: '',
      additionTwo: '',
      additionThree: '',
      additionFour: '',
      superAddition: '',
      address: '',
      formattedPrice: '',
      editorModules: {
        toolbar: [['bold', 'underline', 'strike']],
      },
    };
  },
  mounted() {
    window.Telegram.WebApp.BackButton.show();
    window.Telegram.WebApp.BackButton.onClick(() => {
      this.backToCatalog();
      window.Telegram.WebApp.BackButton.hide();
    });
  },
  methods: {
    onPhotosChange(event) {
      if (event.moved) {
        const { oldIndex, newIndex } = event.moved;
        const movedFile = this.photos.splice(oldIndex, 1)[0];
        this.photos.splice(newIndex, 0, movedFile);
      }
    },
    triggerHapticFeedback() {
      if (window.Telegram && window.Telegram.WebApp && window.Telegram.WebApp.HapticFeedback) {
        const haptic = window.Telegram.WebApp.HapticFeedback;
        haptic.impactOccurred('medium');
      } else {
        console.log('HapticFeedback не поддерживается');
      }
    },

    handleFileChange(event) {
      const files = event.target.files;
      if (files.length) {
        const newFiles = Array.from(files);
        this.photos = [...this.photos, ...newFiles];
        this.photoUrls = [...this.photoUrls, ...newFiles.map((file) => URL.createObjectURL(file))];
      }
    },

    removePhoto(index) {
      this.photos.splice(index, 1);
      this.photoUrls.splice(index, 1);
    },

    backToCatalog() {
      this.triggerHapticFeedback();
      this.isOpen = false;
      setTimeout(() => {
        this.$emit('backToCatalog');
      }, 250);
    },

    async submitForm() {
      const formData = new FormData();
      this.photos.forEach((file) => {
        formData.append('files', file);
      });
      formData.append('category', this.category);
      formData.append('header', this.header);
      formData.append('description', this.description);
      formData.append('price', this.price);
      formData.append('additions_one', this.additionOne);
      formData.append('additions_two', this.additionTwo);
      formData.append('additions_three', this.additionThree);
      formData.append('additions_four', this.additionFour);
      formData.append('super_additions', this.superAddition);
      formData.append('address', this.address);

      this.$store.commit('changeLoading', true);
      await this.$store.dispatch('addObject', formData);
      this.$store.commit('changeLoading', false);

      this.backToCatalog();
    },

    formatPriceInput() {
      let value = this.formattedPrice.replace(/\D/g, '');
      value = value.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      this.formattedPrice = value;
      this.price = value.replace(/\s/g, '');
    },
  },
};
</script>

<style lang="scss" module>
hr {
  opacity: 0.1;
  margin: 30px 0;
}

@keyframes show {
  0% {
    left: -100%;
  }
  100% {
    left: 0;
  }
}

@keyframes hide {
  0% {
    left: 0;
  }
  100% {
    left: -100%;
  }
}

.wrapper {
  position: fixed;
  overflow-y: auto;
  background: $background;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  margin: 0 auto;
  animation-name: show;
  animation-duration: 0.25s;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }

  &.hide {
    animation-name: hide;
    animation-duration: 0.26s;
  }
}

.content {
  padding: 116px 16px 300px 16px;
}

.deleteIndent {
  padding: 16px 16px 16px 16px;
}

.back {
  position: fixed;
  z-index: 2;
  top: 16px;
  left: 16px;
  width: 39px;
  height: 39px;
}

.img {
  margin-right: 8px;
  width: 12px;
  height: 12px;
}

.hidden {
  display: none;
}

.custom_button {
  margin: 0 auto;
  margin-bottom: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 17px 0px;
  width: 100%;
  background-color: $primary;
  color: $black;
  border: none;
  border-radius: 12px;
  text-align: center;
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
}

.photo {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 30px;
  margin-bottom: 20px;

  .photo_preview {
    position: relative;
    width: 100%;
    height: 250px;
    overflow: hidden;
    border-radius: 12px;

    .photo_item {
      width: 100%;
      height: -webkit-fill-available;
      object-fit: cover;
    }
  }
}

.remove_button {
  position: absolute;
  display: flex;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  padding: 16px 30px;
  background-color: $red;
  color: $black;
  border: none;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  .delete_icon {
    width: 12px;
    margin: 0 8px 0 0;
  }
}

.field {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-bottom: 10px;
}

.title {
  margin-right: 16px;
  display: flex;
  align-items: center;
  padding: 14px 0px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: $white;
}

.button_transparent {
  flex-grow: 1;
  padding: 14px 0px 14px 16px;
  background-color: transparent;
  color: $white;
  border: 1px solid $white;
  border-radius: 12px;
  outline: none;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  box-sizing: border-box;
  overflow: auto;
  &.addition {
    margin: 0 0 12px 0;
    &:last-child {
      margin: 0;
    }
  }
}

.editor_container {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  border: 1px solid $white;
  border-radius: 12px;
  color: white;
  overflow: hidden;
  background-color: transparent;
}

.editor .ql-toolbar {
  background-color: transparent;
  border-bottom: 1px solid $white;
  padding: 0 8px;
}

.editor .ql-container {
  padding: 14px 16px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: white;
  --webkit-text-color: white;
  background-color: transparent;
}

input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.button_transparent::placeholder {
  color: $white;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
}

.button {
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 17px 0px;
  width: 100%;
  background-color: $primary;
  color: $black;
  border: none;
  border-radius: 12px;
  text-align: center;
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
}

.photo_preview {
  position: relative;
  margin-bottom: 10px;
  transition: transform 0.2s;

  &:active {
    cursor: grabbing;
  }
}

.photo_item {
  cursor: move;
}

.sortable-chosen {
  opacity: 0.7;
  transform: scale(0.98);
}

.sortable-ghost {
  opacity: 0.5;
  background: #f8f8f8;
  border-radius: 4px;
}
</style>

<style>
.p-editor-toolbar {
  display: none !important;
}
</style>
